import { Alert } from "../../types";
import {
  startAlertService,
  stopAlertService,
} from "../../services/alertService";
import { initialAlerts } from "../../data/initialData";

export interface AlertSlice {
  // State
  alerts: Alert[];
  alertServiceEnabled: boolean;

  // Actions
  addAlert: (alert: Alert) => void;
  acknowledgeAlert: (id: string) => void;
  markAlertInteracted: (id: string) => void;
  removeAlert: (id: string) => void;
  toggleAlertService: () => void;
}

export const createAlertSlice = (set: any, get: any): AlertSlice => ({
  // Initial state
  alerts: initialAlerts,
  alertServiceEnabled: false,

  // Actions
  addAlert: (alert) => {
    set((state: any) => ({
      alerts: [alert, ...state.alerts],
      currentAlertIndex: 0,
    }));
  },

  acknowledgeAlert: (id) =>
    set((state: any) => ({
      alerts: state.alerts.map((alert: Alert) =>
        alert.id === id
          ? { ...alert, acknowledged: true, interacted: true }
          : alert
      ),
    })),

  markAlertInteracted: (id) =>
    set((state: any) => ({
      alerts: state.alerts.map((alert: Alert) =>
        alert.id === id ? { ...alert, interacted: true } : alert
      ),
    })),

  removeAlert: (id) =>
    set((state: any) => ({
      alerts: state.alerts.filter((alert: Alert) => alert.id !== id),
    })),

  toggleAlertService: () => {
    const { alertServiceEnabled, addAlert } = get();
    const newEnabled = !alertServiceEnabled;

    if (newEnabled) {
      startAlertService(addAlert);
    } else {
      stopAlertService();
    }

    set({ alertServiceEnabled: newEnabled });
  },
});
